import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _isNil from "lodash/isNil";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import { PLOT_DATA_LOADED, PLOT_DATA_LOADING, PLOT_DATA_ERROR } from 'redux/actionTypes/componentConfig';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import fetchWork from 'utils/work/fetchWork';
var getMotifAnalysis = function getMotifAnalysis(experimentId, plotUuid, config) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var timeout, body, res, data, warning, chainCount, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_isNil(config.selectedChain)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            timeout = getTimeoutForWorkerTask(getState(), 'PlotData');
            body = {
              name: 'MotifAnalysis',
              motifLength: config.motifLength,
              selectedChain: config.selectedChain,
              firstCellSetKeys: config.firstCellSetKeys,
              secondCellSetKeys: config.secondCellSetKeys,
              motifType: config.motifType
            };
            _context.prev = 4;
            dispatch({
              type: PLOT_DATA_LOADING,
              payload: {
                plotUuid: plotUuid
              }
            });
            _context.next = 8;
            return fetchWork(experimentId, body, getState, dispatch, {
              timeout: timeout
            });
          case 8:
            res = _context.sent;
            data = res.motifs, warning = res.warning, chainCount = res.chainCount;
            dispatch({
              type: PLOT_DATA_LOADED,
              payload: {
                plotUuid: plotUuid,
                plotData: {
                  data: data,
                  chainCount: chainCount,
                  warning: warning
                }
              }
            });
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_PLOT_DATA);
            dispatch({
              type: PLOT_DATA_ERROR,
              payload: {
                plotUuid: plotUuid,
                error: errorMessage
              }
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 13]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default getMotifAnalysis;